// extracted by mini-css-extract-plugin
export var lg = "_em-7";
export var md = "_em-6";
export var placeholderContainer = "_em-1";
export var placeholderIcon = "_em-2";
export var productImage = "_em-0";
export var sm = "_em-5";
export var xl = "_em-8";
export var xs = "_em-4";
export var xxs = "_em-3";